// src/ai/speechService.js

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

class SpeechService {
    constructor() {
        this.recognition = null;
        this.onResult = () => {};
        this.onError = () => {};
        this.onEnd = () => {};
    }

    init({ onResult, onError, onEnd }) {
        this.onResult = onResult;
        this.onError = onError;
        this.onEnd = onEnd;
    }

    start() {
        if (!SpeechRecognition) {
            this.onError({ error: 'unsupported' });
            return;
        }

        // Eğer zaten bir dinleme varsa, önce onu durdur ve temizle
        if (this.recognition) {
            this.recognition.abort();
        }
        
        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'tr-TR';
        this.recognition.interimResults = false;
        this.recognition.continuous = false;

        this.recognition.onresult = (event) => {
            const transcript = event.results[event.results.length - 1][0].transcript.trim();
            this.onResult(transcript);
            this.stop(); // Sonuç alındıktan sonra hemen durdur.
        };

        this.recognition.onerror = (event) => {
            this.onError(event);
        };

        this.recognition.onend = () => {
            this.onEnd();
        };

        this.recognition.start();
    }

    stop() {
        if (this.recognition) {
            this.recognition.stop();
        }
    }
}

// Singleton instance oluşturuyoruz
export const speechService = new SpeechService();